import { Component, OnInit } from '@angular/core';
import { QuizService } from '../../service/quiz.service';
import { SessionService } from '../../service/session.service';
import { TaskService } from 'src/app/service/tasks.service';


import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LoadingDialog } from '../dialogs/loading/loading.dialog';
import { TranslateService } from '@ngx-translate/core';

interface Question {
  question_no: number,
  question: string,
  id: number,
  answer_type: string,
  options: object
}

@Component({
  selector: 'app-personality-survey',
  templateUrl: './personality-survey.component.html',
  styleUrls: ['./personality-survey.component.css']
})
export class PersonalitySurveyComponent implements OnInit {
  options = [
    'Yes',
    'No'];
  questions: Question[] = [];
  radioOptions: any = [];
  answer: any = {}
  postRequest: any = { question_id: [], answer: [], type: "SPQ" };
  done = false;
  charged2 = false;
  dialogRef: MatDialogRef<LoadingDialog, any>
  loading = true
  displayedColumns: string[] = ['question_no', 'Answers'];
  index = 0
  testCompleted = false
  constructor(
    private quizService: QuizService,
    private router: Router,
    private dialog: MatDialog,
    public translate: TranslateService,
    private taskService: TaskService
  ) { }

  ngOnInit() {

    this.quizService.check_exp("SPQ")
      .then(data => {
        this.done = data.body.valid
        this.charged2 = true
        if (this.done) {
          this.quizService.get_questions('SPQ').then((data: any) => {
            console.log(data.body);
            this.questions = data.body;
            for (const key in data.body) {
              this.answer[key] = [false, false]
            }
            this.loading = false
          });
        }
        else{
          this.loading = false
        }
      })

  }

  public get charged(): boolean {
    return this.questions.length > 0
  }
  public get isDisabled(): boolean {
    for (const key in this.answer) {
      if (this.answer[key].indexOf(true) == -1) return true
    }
    return false
  }

  select (index, answer) {

    let auxList = [false, false]

    auxList[answer] = !this.answer[index][answer]
    this.answer[index] = auxList

  }

  onSubmit() {
    console.log(this.answer, null, 2)
    for (const i in this.answer) {
      this.postRequest.question_id.push(this.questions[i].id)
      console.log(i)
      let pos = this.answer[i].indexOf(true)
      console.log(i)

      this.postRequest.answer.push({text:this.options[pos], id: this.options[pos] == 'Yes' ? 1 : 0});
    }
    this.dialogRef = this.dialog.open(LoadingDialog, { disableClose: true })
    this.Post_answers(this.postRequest);
    // console.log(this.postRequest, null, 2)
    // localStorage.clear();
    // window.location.href = '/logon';
  }
  Post_answers(data) {
    this.quizService
      .post_answers(data)
      .then(() => {
        this.dialogRef.close()
        this.testCompleted = true
        setTimeout(() => {
          this.router.navigate([''])
        }, 3000)
      }).then(()=>{
        this.taskService.saveCompletedTask({"type":"Personality"})
      })
      .catch(e => {
        console.log(e);
        this.router.navigate(['']);
      });
  }

  lowercaseString(string : string){
    return string[0].toUpperCase() + string.slice(1).toLowerCase()
  }
}
